import { ArrowUpIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";
import "regenerator-runtime/runtime";
import { useModalContext } from "../../contexts/modals";
import Tooltip from "../Tooltip";
// @ts-ignore
import clsx from "clsx";
import { observer } from "mobx-react";
import {
  EnumAssetAdvancedProcessing,
  EnumAssetVectorEmbeddings,
} from "../../__generated__/graphql";
import { useToastsContext } from "../../contexts/toasts";
import useIsMobile from "../../hooks/useIsMobile";
import useStores from "../../hooks/useStores";
import AudioInput from "../Input/AudioInput";
// import ProPlanWall from "../ProPlanWall";
import Disclaimer from "../Terms/Disclaimer";
// import isURL from "validator/lib/isURL";
import * as Dialog from "@radix-ui/react-dialog";
import { computed } from "mobx";
import { AttachmentIcon } from "../../icon-imports";
import Asset from "../../models/Asset";
import { retryFileAttachmentProcessing } from "../../utils/ProcessAttachments";
import AttachmentProgress from "./AttachmentProgress";
import ChatAttachmentInput from "./ChatAttachmentInput";
import CompactAttachmentBar from "./CompactAttachmentBar";
import UploadProgress from "./UploadProgress";

const MAX_NUMBER_OF_ATTACHMENTS = 10;

/**
 * Converts a number of bytes to a human-readable string representation.
 * @param bytes - The number of bytes to format.
 * @returns A string representing the bytes in a human-readable format.
 */
export function formatBytesToReadable(bytes: number | undefined) {
  if (!bytes) {
    return "0 Bytes";
  }

  const groups = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, groups);
  const suffix = "BKMGTPEZY"[groups] + "B";

  return value.toFixed(2).replace(/\.?0+$/, "") + " " + suffix;
}

export function DosDontsLinkInput() {
  return (
    <div className="mt-4 text-[13px] text-gray-500">
      Works best with public webpages and YouTube videos. For private documents
      (Google Docs, LMS files), use file upload instead.
    </div>
  );
}

type ChatMessageInputProps = {
  message: string;
  onMessageChange: (e: any) => void;
  onSend: (e: any) => void;
  assetIds: string[];
  setAssetIds: React.Dispatch<React.SetStateAction<string[]>>;
  hideButtons?: boolean;
  disabled?: boolean;
  askAlayna?: boolean;
  isGPTChat?: boolean;
};

function ChatMessageInput(props: ChatMessageInputProps) {
  // Currently local states, but will be moved to parent component
  const {
    numOpenModals,
    //  addModal
  } = useModalContext();
  const { addToast } = useToastsContext();
  const {
    message,
    onMessageChange,
    disabled,
    onSend,
    assetIds,
    setAssetIds,
    hideButtons,
  } = props;

  console.log("disabled", disabled);

  // Add new state variables to track different asset states
  const [uploadingAssets, setUploadingAssets] = useState<
    {
      id: string;
      name: string;
      progress: number;
    }[]
  >([]);

  const { assets } = useStores();

  const textareaRef: any = useRef(null);

  const isMobile = useIsMobile();

  // useEffect(() => {
  //   setTimeout(() => {
  //     setUploadingAssets([
  //       {
  //         id: "cm3psilnb0003xthiui50wujj",
  //         name: "samplepptx.pptx",
  //         progress: 0,
  //       },
  //     ]);

  //     setTimeout(() => {
  //       setUploadingAssets([
  //         {
  //           id: "cm3psilnb0003xthiui50wujj",
  //           name: "samplepptx.pptx",
  //           progress: 50,
  //         },
  //       ]);
  //     }, 1500);

  //     setTimeout(() => {
  //       setUploadingAssets([]);

  //       setAssetIds(["cm3psilnb0003xthiui50wujj"]);
  //       assets.add({
  //         acl: EnumAssetAcl.Private,
  //         assetType: EnumAssetAssetType.Import,
  //         content: {
  //           name: "samplepptx.pptx",
  //         },
  //         contentType:
  //           "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  //         courseId: null,
  //         createdAt: "2024-11-20T10:33:31.829Z",
  //         id: "cm3psilnb0003xthiui50wujj",
  //         key: "uploads/cm1ggontr0000xtw1va0n5x5y/d6d27c9b-f390-4cee-8539-8037cddfeba7/sample-2pages.pdf",
  //         resourceId: null,
  //         size: 155570,
  //         updatedAt: "2024-11-20T10:33:31.829Z",
  //         userId: "cm1ggontr0000xtw1va0n5x5y",
  //         vectorEmbeddings: EnumAssetVectorEmbeddings.InProgress,
  //       });
  //     }, 3000);

  //     // setTimeout(() => {
  //     //   assets.save({
  //     //     id: "cm3psilnb0003xthiui50wujj",
  //     //     vectorEmbeddings: EnumAssetVectorEmbeddings.Error,
  //     //   });
  //     // }, 6000);
  //   }, 8000);
  // }, []);

  // Use computed values from MobX store
  const processingAssets = computed(() => {
    if (!assets) return [];
    return props.assetIds
      .map((id) => assets.get(id))
      .filter(
        (asset): asset is Asset =>
          asset !== undefined &&
          (asset.vectorEmbeddings === EnumAssetVectorEmbeddings.InProgress ||
            asset.vectorEmbeddings === EnumAssetVectorEmbeddings.Error ||
            // Also show dialog when advanced processing (visual PDF) is in progress
            asset.advancedProcessing ===
              EnumAssetAdvancedProcessing.InProgress ||
            asset.advancedProcessing === EnumAssetAdvancedProcessing.Error)
      );
  });

  // Get all attached assets (show inline as previews)
  // Show all assets regardless of processing status - pills should always be visible
  const attachedAssets = computed(() => {
    if (!assets) return [];
    return props.assetIds
      .map((id) => assets.get(id))
      .filter((asset): asset is Asset => asset !== undefined);
  });

  // Add this computed value for button state
  const isSubmitDisabled = disabled || !message.trim();

  // Maintain focus after message is cleared (after sending)
  useEffect(() => {
    if (textareaRef.current && message === "") {
      // Focus the textarea after message is cleared (message sent)
      setTimeout(() => {
        if (textareaRef.current) {
          textareaRef.current.focus();
        }
      }, 0);
    }
  }, [message]);

  // Function to handle sending a message
  const handleSend = () => {
    // We need to ensure that the asset embeddings have been completed before we allow user to send the message
    // This is because we need the embeddings to be able to process the message

    if (!message || message.trim() === "") {
      addToast("Please enter a message.", {
        type: "warning",
      });
      return;
    }
    onSend({
      query: {
        assetId: "",
      },
    });

    // Reset the textarea's height to its default after sending the message
    if (textareaRef.current) {
      textareaRef.current!.style.height = "auto";
    }
  };

  return (
    <div>
      {numOpenModals === 0 && uploadingAssets.length > 0 && (
        <Dialog.Root open={true}>
          <Dialog.Portal>
            <Dialog.Overlay className="z-[1003] fixed inset-0 bg-blackA6 data-[state=open]:animate-overlayShow" />
            <Dialog.Content className="z-[1004] fixed left-1/2 top-1/2 max-h-[85vh] max-w-[90vw] min-w-[750px] -translate-x-1/2 -translate-y-1/2 rounded-md bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
              <UploadProgress assets={uploadingAssets} />
            </Dialog.Content>
          </Dialog.Portal>
        </Dialog.Root>
      )}
      {numOpenModals === 0 && processingAssets.get().length > 0 && (
        <Dialog.Root open={true}>
          <Dialog.Portal>
            <Dialog.Overlay className="z-[1001] fixed inset-0 bg-blackA6 data-[state=open]:animate-overlayShow" />
            <Dialog.Content className="z-[1002] fixed left-1/2 top-1/2 max-h-[85vh] max-w-[90vw] min-w-[750px] -translate-x-1/2 -translate-y-1/2 rounded-md bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
              <AttachmentProgress
                assets={processingAssets.get()}
                onRetry={async (assetId) => {
                  assets.save({
                    id: assetId,
                    vectorEmbeddings: EnumAssetVectorEmbeddings.InProgress,
                    advancedProcessing: EnumAssetAdvancedProcessing.InProgress,
                  });
                  await retryFileAttachmentProcessing(assetId);
                }}
              />
            </Dialog.Content>
          </Dialog.Portal>
        </Dialog.Root>
      )}
      {/* Render multiple attachments - compact bar with popover for managing */}
      {attachedAssets.get().length > 0 && (
        <CompactAttachmentBar
          assets={attachedAssets.get()}
          onRemove={(id) => {
            props.setAssetIds(props.assetIds.filter((aid) => aid !== id));
          }}
        />
      )}

      <div className="flex flex-row gap-4 w-full">
        <div className="relative flex w-full">
          {!props.hideButtons && (
            <div className="absolute left-0 bottom-[2px] m-1 ml-4 mt-0 flex-col pb-2">
              <div className="flex">
                {
                  // Render attachment menu
                  // PRO plan gating temporarily disabled
                  assetIds.length >= MAX_NUMBER_OF_ATTACHMENTS ? (
                    <Tooltip
                      content={`Maximum ${MAX_NUMBER_OF_ATTACHMENTS} attachments allowed`}
                      sideOffset={15}
                      delayDuration={0}
                      asChild={true}
                    >
                      <button
                        id="ask-alayna-attachment-input"
                        className="border-gray-700 flex rounded-md border-solid cursor-not-allowed opacity-50"
                        aria-label="Maximum attachments reached"
                        disabled
                        onClick={(e) => e.stopPropagation()}
                      >
                        <AttachmentIcon className="text-gray-700 h-7 w-7" />
                      </button>
                    </Tooltip>
                  ) : (
                    <ChatAttachmentInput
                      assetIds={assetIds}
                      setAssetIds={setAssetIds}
                      setUploadingAssets={setUploadingAssets}
                      disabled={disabled}
                    />
                  )
                }

                <Tooltip content="Speech to Text" sideOffset={15}>
                  <div className="ml-[0.35em] flex">
                    <AudioInput
                      disabled={disabled}
                      setTranscript={(transcript: any) => {
                        if (disabled) return;
                        onMessageChange({
                          target: { value: transcript },
                        });
                      }}
                    />{" "}
                  </div>
                </Tooltip>
              </div>
            </div>
          )}
          {/* Text input */}
          <textarea
            id="ask-alayna-chat-input"
            ref={textareaRef}
            className={clsx(
              "bg-gray-400 h-auto w-full resize-y rounded-[20px] border-none py-4 placeholder-gray-600",
              props.hideButtons ? "pl-4 pr-16" : "pl-24",
              props.hideButtons ? "" : isMobile ? "pr-16" : "pr-16"
            )}
            placeholder={
              props.hideButtons
                ? "Provide Instructions..."
                : "Message Alayna..."
            }
            onChange={(e) => {
              e.target.style.height = "auto";
              e.target.style.height = `${e.target.scrollHeight}px`;
              onMessageChange(e);
            }}
            rows={hideButtons ? 2 : 1}
            value={message}
            autoFocus={true}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleSend(); // Call the handleSend function when Enter is pressed without Shift
              } else if (e.key === "Enter" && e.shiftKey) {
                // Allow newline for Shift + Enter
              }
            }}
          />

          {/* Send button */}
          <div className="absolute inset-y-0 right-0 m-1 mr-4 flex flex-col items-end justify-end gap-2 pb-2">
            <button
              className={clsx(
                "p-2 rounded-full transition-all",
                isSubmitDisabled
                  ? "bg-gray-100 cursor-not-allowed"
                  : "bg-black hover:bg-gray-800 active:bg-gray-700"
              )}
              onClick={handleSend}
              disabled={isSubmitDisabled}
              aria-label="Send message"
            >
              <ArrowUpIcon
                className={clsx(
                  "h-5 w-5 font-bold stroke-4",
                  isSubmitDisabled ? "text-gray-700" : "text-white"
                )}
              />
            </button>
          </div>
        </div>
      </div>

      <div
        className={clsx(
          "flex pt-2",
          hideButtons || isMobile ? "justify-between" : "justify-start"
        )}
      >
        {!hideButtons && !isMobile && (
          <div className="flex w-full items-center justify-between pt-2">
            <Disclaimer />

            <div className="text-[12px] text-gray-500">
              ⏎ to Submit, Shift + ⏎ for New Line
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default observer(ChatMessageInput);
